import { createContext, useContext, useEffect, useState } from "react";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
    const [filter, setFilter] = useState(() => {
        const stored = localStorage.getItem("filter");
        return stored || "food";
    });

    const [isServiceChecked, setIsServiceChecked] = useState(() => {
        const stored = localStorage.getItem("isServiceChecked");
        return stored ? JSON.parse(stored) : false;
    });

    useEffect(() => {
        localStorage.setItem("filter", filter);
    }, [filter]);

    useEffect(() => {
        localStorage.setItem("isServiceChecked", JSON.stringify(isServiceChecked));
    }, [isServiceChecked]);

    return (
        <FilterContext.Provider
            value={{
                filter,
                setFilter,
                isServiceChecked,
                setIsServiceChecked,
            }}
        >
            {children}
        </FilterContext.Provider>
    );
};

export const useFilter = () => useContext(FilterContext);